<template>
  <v-container fluid class="pa-0">
    <v-card class="mb-4">
      <v-toolbar card color="primary" dark dense>
        <v-spacer></v-spacer>
        <v-toolbar-title>{{$t('inGame.supplychainGraph')}}</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text style="height:600px">
        <div id="mynetwork"></div>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import vis from "vis-network/dist/vis-network";
import Config from "@/config";
export default {
  name: "Graph",
  data() {
    return {
      search: ""
    };
  },
  async mounted() {
    await this.$nextTick();
    let edgeId = 1;
    var nodes = [];
    var edges = [];

    for (const company of this.$store.state.games.current.companies) {
      nodes.push({
        id: company._id.toString(),
        label: company.name,
        title: company.name,
        shape: "circularImage",
        image: this.config.filesUrl + company.instance + "/logo/" + company.companieSettings.logo
      });
      for (const supplier of company.data.suppliers) {
        let tempVal = 0
        if (supplier.orders.length) {
          tempVal = supplier.orders.reduce((prev, curr) => prev += curr, 0) / supplier.orders.length
        } 
        if (!company.assignable) {
          tempVal = company.data.resume.averageOrderQuantity
        }
        if (tempVal === 0) {
          tempVal = 1
        }
        tempVal = (tempVal * 100).toFixed(0)
        edges.push({
          color: "#90A4AE",
          value: tempVal,
          id: edgeId,
          from: supplier.supplier,
          to: company._id,
          smooth: {
            enabled: true,
            type: "curvedCW",
            roundness: 0.18
          }
        });
        edgeId++;
      }
      for (const client of company.data.clients) {
        let tempVal = 0
        if (client.deliveries.length) {
          tempVal = client.deliveries.reduce((prev, curr) => prev += curr, 0) / client.deliveries.length
        } else {
          tempVal = 1
        }
        tempVal = (tempVal * 100).toFixed(0)
        edges.push({
          color: "#5C6BC0",
          value: tempVal,
          id: edgeId,
          from: company._id,
          to: client.client,
          smooth: {
            enabled: true,
            type: "curvedCCW",
            roundness: 0.18
          }
        });
        edgeId++;
      }
    }

    var container = document.getElementById("mynetwork");
    var data = {
      nodes: new vis.DataSet(nodes),
      edges: new vis.DataSet(edges)
    };
    var options = {
      locale: "fr",
      interaction: {
        dragNodes: false,
        hover: true,
        multiselect: true,
        tooltipDelay: 50
      },
      layout: {
        hierarchical: {
          enabled: true,
          levelSeparation: 220,
          nodeSpacing: 220,
          parentCentralization: true,
          direction: "LR",
          sortMethod: "directed"
        }
      },
      nodes: {
        borderWidth: 6,
        size: 40,
        color: {
          border: "#3F51B5"
        }
      },
      edges: {
        color: "black"
      },
      physics: false
    };

    var network = new vis.Network(container, data, options);
    network.on("selectNode", function(params) {
      network.focus(params.nodes, { scale: 1 });
    });
  },
  computed: {
    config() {
      return Config;
    }
  }
};
</script>
<style >
#mynetwork {
  width: 100%;
  height: 100%;
  cursor: pointer;
}

</style>

